import { render, staticRenderFns } from "./integralPeopleItemEdit.vue?vue&type=template&id=696c0bd3&scoped=true&"
import script from "./integralPeopleItemEdit.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemEdit.vue?vue&type=style&index=0&id=696c0bd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c0bd3",
  null
  
)

export default component.exports